import setTransition from './setTransition.js';
import transitionStart from './transitionStart.js';
import transitionEnd from './transitionEnd.js';
export default {
  setTransition,
  transitionStart,
  transitionEnd
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/swiper/core/transition/index.js
// module id = 8dKP
// module chunks = 13